export const CDN_BASE = 'https://cdn.toddham.com';

const IS_PROD = typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'production';
const ENABLE_CDN = (typeof process !== 'undefined' && process.env && process.env.REACT_APP_USE_CDN === 'true') || IS_PROD;
const ENABLE_CDN_MODELS = typeof process !== 'undefined' && process.env && process.env.REACT_APP_CDN_MODELS === 'true';

export function toCdn(path) {
  if (!path) return path;
  if (typeof path !== 'string') return path;
  if (/^https?:\/\//i.test(path)) return path;
  if (!ENABLE_CDN) return path;
  if (path.startsWith('/images/')) return `${CDN_BASE}${path}`;
  return path;
}

export function toModel(path) {
  if (!path) return path;
  if (typeof path !== 'string') return path;
  if (/^https?:\/\//i.test(path)) return path;
  // Only serve models from CDN if explicitly enabled; otherwise keep local
  if (ENABLE_CDN && ENABLE_CDN_MODELS && path.startsWith('/images/models/')) {
    return `${CDN_BASE}${path}`;
  }
  return path;
}


